// extracted by mini-css-extract-plugin
export var standaloneTable = "_ff-0";
export var standaloneTableWithBodyFill = "_ff-1";
export var withExtraHeader = "_ff-2";